import ForgotPassword from "../../src/pages/ForgotPassword";
import ResetPassword from "../../src/pages/ResetPassword";
import { ProductListing } from "../../src/pages/ProductListing";
import { ProductListingNotFound } from "../../src/pages/ProductListingNotFound";
import { Alert } from "../../src/pages/Alert";
import HeaderTotalCartItems from "../../src/component/Global/Cart/HeaderTotalCartItems";
import UniversalSearch from "../../src/component/UniversalSearch";
import { ProductDetail } from "../../src/pages/ProductDetail";
import { ProductCompare } from "../../src/pages/ProductCompare";
import ProductCompareMiniSlider from "../../src/component/Product/BottomCompareProduct/ProductCompareMiniSlider";
import { Cart } from "../../src/pages/Cart";
import { Checkout } from "../../src/pages/Checkout";
import { CompareProduct } from "../../src/pages/CompareProduct";
import { Quote } from "../../src/pages/Quote";

import Auth from "@system/config/auth";
import Product from "@system/config/product";
import ProductCompareConfig from "@system/config/product-compare";
import DashboardAlerts from "@system/config/dashboard-alerts";
import CheckOut from "@system/config/checkout";
import CartConfig from "@system/config/cart";
import QuoteConfig from "@system/config/quote";
import BomConfig from "@system/config/bom";
import OrderConfig from "@system/config/order";
import ForecastConfig from "@system/config/forecast";
import { BOM } from "src/pages/BOM";
import { Order } from "src/pages/Order";
import APIRouteChain from "src/pages/APIRouteChain";
import { Forecast } from "src/pages/Forecast";
import { ProfileAccountInformation } from "src/pages/ProfileAccountInformation";
import { HomePageContent } from "src/pages/HomePageContent/HomePageContent";
import { ProductDetailBuyBoxSeparatedComponent } from "../../src/pages/ProductDetailBuyBoxSeparatedComponent";
import { ProductDetailContentSeparatedComponent } from "../../src/pages/ProductDetailContentSeparatedComponent";
import { QuoteCart } from "src/pages/QuoteCart";
import SuccessCheckout from "src/pages/Checkout/SuccessCheckout";
import Constants from "src/support/Constants";
import AdminConfig from "@system/config/admin";
import UserManagementTab from "src/pages/Admin/UserManagementTab";
import UserDetail from "src/pages/Admin/userManagement/UserDetail";
import AccountDetail from "src/pages/Admin/Accounts/AccountDetail";
import Registration from "src/pages/Registration";
import UserReverification from "src/pages/UserReverification";
import UserReverifications from "@system/config/user-reverification";
import CrossReferenceTool from "src/pages/CrossReferenceTool";
import BOMManagement from "src/pages/Admin/BOM/BOMManagement";
import AdminBOMDetails from "src/pages/Admin/BOM/AdminBOMDetails";

class MicroComponents {

    static chain = [
        { name: 'ForgotPassword', element: ForgotPassword, url: Auth.getForgotPasswordPageRouteURL() },
        { name: 'ResetPassword', element: ResetPassword, url: Auth.getResetPasswordPageRouteURL() },
        { name: 'ProductListing', element: ProductListing, url: Product.getProductListingPageRouteURL() },
        {
            name: 'ProductListingNotFound',
            element: ProductListingNotFound,
            url: Product.getProductListingNotFoundPageRouteURL()
        },
        { name: 'PCNAlerts', element: Alert, url: DashboardAlerts.getAlertRouteURL() },
        { name: 'PCNAlert', element: Alert, url: DashboardAlerts.getAlertRouteURL() },
        { name: 'EOLAlerts', element: Alert, url: DashboardAlerts.getAlertRouteURL() },
        { name: 'EOLAlert', element: Alert, url: DashboardAlerts.getAlertRouteURL() },
        { name: 'Alert', element: Alert, url: DashboardAlerts.getAlertRouteURL() },
        { name: 'ProductDetail', element: ProductDetail, url: Product.getProductDetailPageRouteURL() },
        { name: 'ProductDetailContentSeparatedComponent', element: ProductDetailContentSeparatedComponent },
        { name: 'ProductDetailBuyBoxSeparatedComponent', element: ProductDetailBuyBoxSeparatedComponent },
        { name: 'ProductCompare', element: ProductCompare, url: ProductCompareConfig.getProductComparePageRouteURL() },
        { name: 'CompareProduct', element: CompareProduct, url: ProductCompareConfig.getProductComparePageRouteURL() },
        { name: 'Checkout', element: Checkout, url: CheckOut.getCheckOutRouteURL() },
        { name: 'Cart', element: Cart, url: CartConfig.getCartPageRouteURL() },
        { name: 'SuccessCheckout', element: SuccessCheckout, url: CheckOut.getCheckOutStatusRouteURL() },
        { name: 'SuccessCheckoutQuote', element: SuccessCheckout, url: CheckOut.getCheckOutStatusRouteURL(Constants.systemModules.Quote) },
        { name: 'Quote', element: Quote, url: QuoteConfig.getQuoteRouteURL() },
        { name: 'Bom', element: BOM, url: BomConfig.getBomRouteURL() },
        { name: 'Order', element: Order, url: OrderConfig.getOrderRouteURL() },
        { name: 'Forecast', element: Forecast, url: ForecastConfig.getForecastRouteURL() },
        ///// Non-URL based components
        { name: 'HeaderTotalCartItems', element: HeaderTotalCartItems },
        { name: 'ProductCompareMiniSlider', element: ProductCompareMiniSlider },
        { name: 'UniversalSearch', element: UniversalSearch },
        { name: 'APIRouteChain', element: APIRouteChain },
        { name: 'Profile', element: ProfileAccountInformation },
        { name: 'HomePageContent', element: HomePageContent },
        { name: 'QuoteCart', element: QuoteCart, url: CartConfig.getQuoteCartPageRouteURL() },
        { name: 'Registration', element: Registration, url: AdminConfig.getRegistrationURL() },
        { name :'CrossReferenceTool', element: CrossReferenceTool, url: Auth.getCrossReferenceToolRouteURL()},         
        { name: 'UserReverification', element: UserReverification, url: UserReverifications.getUserReverificationPageRouteURL()},

        // admin console components start
        { name: 'UserManagementTab', element: UserManagementTab, url: AdminConfig.getAdminUserManagementURL() },
        { name: 'UserDetail', element: UserDetail, url: AdminConfig.getAdminUserDetailURL() },
        { name: 'AccountDetail', element: AccountDetail, url: AdminConfig.getAdminAccountDetailURL() },
        { name: 'BOMManagement', element: BOMManagement, url: AdminConfig.getAdminBOMManagementURL() },
        { name: 'AdminBOMDetails', element: AdminBOMDetails, url: AdminConfig.getAdminBOMDetailURL() }
        // admin console components end
    ];
}

export default MicroComponents;